"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _XcPlugin = /*#__PURE__*/ _interop_require_default(require("./XcPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let XcStoragePlugin = class XcStoragePlugin extends _XcPlugin.default {
};
const _default = XcStoragePlugin;
